document.addEventListener('DOMContentLoaded', function() {
    const jsonElement = document.getElementById('variant-json');
    if (!jsonElement) return;

    const variantData = JSON.parse(jsonElement.textContent);
    const container = document.querySelector('#cc-pdp-option-wrapper');
    const rows = document.querySelectorAll('.cc-variant-option-row');

    const selectedContainer = document.getElementById('selected-variants-container');
    const template = document.getElementById('selected-variant-template');
    const footer = document.getElementById('cc-pdp-buy-footer');
    const form = container ? container.closest('form') : null;

    // 초기화: 각 variant에 last_cart_qty 추가
    variantData.forEach(v => v.last_cart_qty = 0);

    // 카트 동기화 함수
    async function syncCartQuantities() {
        try {
            const res = await fetch(routes.cart_url, {
                headers: { "Accept": "application/json" }
            });
            const cartData = await res.json();

            // 먼저 모든 variant의 last_cart_qty를 0으로 리셋
            variantData.forEach(v => v.last_cart_qty = 0);

            // 카트에 있는 항목들의 수량 반영
            if (cartData.items) {
                cartData.items.forEach(item => {
                    const variant = variantData.find(v => v.id === item.variant_id);
                    if (variant) {
                        variant.last_cart_qty = item.quantity;
                    }
                });
            }

            console.log("카트 동기화 완료:", variantData.map(v => ({
                id: v.id,
                max: v.max_limit,
                inCart: v.last_cart_qty,
                available: v.max_limit - v.last_cart_qty
            })));

            refreshOptionState();
        } catch (err) {
            console.error("카트 동기화 실패:", err);
        }
    }

    // 가용 수량 계산 헬퍼
    function getAvailableQty(variant) {
        return Math.max(0, variant.max_limit - variant.last_cart_qty);
    }

    // 초기 로드 시 카트 동기화
    syncCartQuantities();

    // 카트 변경 시 동기화 (PUB_SUB 이벤트 구독)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, syncCartQuantities);
    }

    const buyBtn = document.querySelector('.cart-direct-buy-btn');
    if (buyBtn) {
        buyBtn.addEventListener('click', executeCheckout);
    }

    window.addEventListener('clear-product-buy-sheet-cart', function() {
        if (selectedContainer) selectedContainer.innerHTML = '';

        //옵션 버튼 선택 상태 해제
        if (container) {
            container.querySelectorAll('.cc-active').forEach(el => el.classList.remove('cc-active'));
        }

        //카트 동기화
        syncCartQuantities();
        //현재 장바구니 가격 재계산 카트 담앗으니 초기화
        updateTotalSummary();
    });

    //텍스트 옵션 배열을 받아 리스트에 추가함, 옵션1, 옵션2 순서대로 와야 매칭가능
    window.addItemsByOptionValues = function(optionTextList) {
        if (!Array.isArray(optionTextList) || optionTextList.length === 0) return;

        //기존 선택 초기화 (충돌 방지)
        container.querySelectorAll('.cc-active').forEach(el => el.classList.remove('cc-active'));

        let matchCount = 0;

        //텍스트 리스트를 순회하며 버튼 찾기
        optionTextList.forEach((textValue, index) => {
            // 예ㅒ시 index: 0이면 첫번째 줄(Color), 1이면 두번째 줄(Size) ...
            const row = rows[index];

            if (row) {
                const btns = row.querySelectorAll('.cc-variant-option-value');

                //해당 줄의 버튼들을 돌면서 텍스트가 일치하는지 확인
                for (let btn of btns) {
                    //data-value와 비교 (공백 제거 후 비교)
                    const btnVal = btn.dataset.value.trim();
                    const targetVal = String(textValue).trim();

                    if (btnVal === targetVal) {
                        btn.classList.add('cc-active');
                        matchCount++;
                        break; // 찾았으면 다음 줄로 이동
                    }
                }
            }
        });

        //모든 옵션 줄에 대해 매칭이 성공했는지 확인
        //옵션이 2개인데 2개 다 선택되었는지
        if (matchCount === rows.length) {
            console.log("옵션 매칭 성공, 리스트에 추가합니다:", optionTextList);

            refreshOptionState(); //상태 갱신 (품절 체크 등)
            addVariantToList();
        } else {
            console.warn("일부 옵션을 찾을 수 없어 추가하지 못했습니다:", optionTextList);
        }

        container.querySelectorAll('.cc-active').forEach(el => el.classList.remove('cc-active'));
        refreshOptionState(); // 상태 초기화
        updateTotalSummary(); // 총액 업데이트
    };

    // 숫자 포맷 (1000 -> 1,000)
    function formatMoney(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    //총액 업데이트 함수
    // [수정] 총액 업데이트 함수
    function updateTotalSummary() {
        const items = selectedContainer.querySelectorAll('.selected-variant-item');
        let totalQty = 0;
        let totalPrice = 0;

        items.forEach(item => {
            const qtyInput = item.querySelector('.quantity__input');
            const priceInput = item.querySelector('.variant-raw-price');

            const qty = parseInt(qtyInput.value, 10) || 0;

            // [중요] Shopify 가격 데이터(cents)에서 뒤의 00을 제거하기 위해 100으로 나눔
            const rawPrice = parseInt(priceInput.value, 10) || 0;
            const price = rawPrice / 100;

            totalQty += qty;
            totalPrice += (price * qty);
        });

        // 텍스트 업데이트
        const ccInfo = footer.querySelector('.cc-information');
        const subjectEl = footer.querySelector('.total-n-subject');
        const priceEl = footer.querySelector('.total-n-price');

        if (totalQty > 0) {
            subjectEl.innerText = `총 ${totalQty}개 상품 금액`;
            priceEl.innerText = `${formatMoney(totalPrice)}원`;
            ccInfo.style.display = 'flex';
        } else {
            ccInfo.style.display = 'none';

        }
    }

    //가용성 체크
    function refreshOptionState() {
        const currentSelections = Array.from(rows).map(row => {
            const activeBtn = row.querySelector('.cc-variant-option-value.cc-active');
            return activeBtn ? activeBtn.dataset.value : null;
        });

        rows.forEach((row, rowIndex) => {
            const buttons = row.querySelectorAll('.cc-variant-option-value');
            buttons.forEach(btn => {
                const btnValue = btn.dataset.value;
                const potentialSelection = [...currentSelections];
                potentialSelection[rowIndex] = btnValue;

                const isPossible = variantData.some(variant => {
                    const matchOptions = variant.options.every((opt, i) => {
                        return potentialSelection[i] === null || String(potentialSelection[i]) === String(opt);
                    });
                    return matchOptions && variant.available;
                });

                btn.classList.toggle('unavailable', !isPossible);
            });
        });
    }

    function clearOptionErrors() {
        rows.forEach(row => {
            const errorEl = row.querySelector('.cc-variant-option-error');
            if (errorEl) errorEl.remove();
        });
    }

    function showOptionErrors() {
        clearOptionErrors();
        rows.forEach(row => {
            const activeBtn = row.querySelector('.cc-variant-option-value.cc-active');
            if (activeBtn) return;
            const subjectEl = row.querySelector('.cc-variant-option-subject');
            const subject = subjectEl ? subjectEl.innerText.trim() : '';
            const valuesEl = row.querySelector('.cc-variant-option-values');
            if (!valuesEl) return;
            const errorEl = document.createElement('div');
            errorEl.className = 'cc-variant-option-error';
            errorEl.textContent = subject ? `${subject}을 선택해주세요.` : '옵션을 선택해주세요.';
            valuesEl.appendChild(errorEl);
        });
    }
    window.showOptionErrors = showOptionErrors;

    //옵션추가될때
    function addVariantToList() {
        const allSelected = container.querySelectorAll('.cc-active').length === rows.length;
        if (!allSelected) return;

        const selectedValues = Array.from(rows).map(row => row.querySelector('.cc-active').dataset.value);
        const subjects = Array.from(rows).map(row => {
            const text = row.querySelector('.cc-variant-option-subject').innerText;
            // 정규식: 괄호 '(' 로 시작해서 ')' 로 끝나는 모든 문자열을 빈카드로 변경
            return text.replace(/\(.*\)/gi, '').trim();
        });

        const matchedVariant = variantData.find(variant => {
            return variant.options.every((opt, index) => String(opt) === String(selectedValues[index]));
        });

        if (matchedVariant) {
            //중복 체크 이미 선택됐음 패스해야함
            if (selectedContainer.querySelector(`.variant-id-input[value="${matchedVariant.id}"]`)) {
                alert("이미 선택된 옵션입니다.");
                return;
            }

            // 가용 수량 계산
            const availableQty = getAvailableQty(matchedVariant);

            const clone = template.content.cloneNode(true);
            const itemRow = clone.querySelector('.selected-variant-item');

            //타이틀 옵션
            const titleText = subjects.map((subj, i) => `${subj}: ${selectedValues[i]}`).join(' / ');
            itemRow.querySelector('.variant-title').innerText = titleText;

            //배송일 or 가격 정보 표시 있으면
            const extraInfoEl = itemRow.querySelector('.variant-extra-info');
            const deliveryInfoEl = itemRow.querySelector('.variant-delivery-info');
            const deliveryLabelEl = deliveryInfoEl?.querySelector('.label');
            const deliveryValueTextEl = deliveryInfoEl?.querySelector('.value');

            const deliverySubjectEl = document.getElementById('delivery-date-subject');
            const deliveryValueEl = document.getElementById('delivery-date-value');
            let deliverySubject = null;
            let deliveryValue = null;
            
            if (deliverySubjectEl && deliveryValueEl) {
                const subj = deliverySubjectEl.value.trim();
                const val = deliveryValueEl.value.trim();
                
                // 둘 다 값이 있을 때만
                if (subj && val) {
                    deliverySubject = subj;
                    deliveryValue = val;
                }
            }

            if (deliveryInfoEl && deliveryLabelEl && deliveryValueTextEl) {
                if (deliverySubject && deliveryValue) {
                    deliveryLabelEl.innerText = deliverySubject;
                    deliveryValueTextEl.innerText = deliveryValue;
                } else {
                    deliveryLabelEl.innerText = "";
                    deliveryValueTextEl.innerText = "";
                }
            } else {
                extraInfoEl.innerText = "";
            }

            // 3. 데이터 심기 (ID, Raw Price)
            itemRow.querySelector('.variant-id-input').value = matchedVariant.id;
            itemRow.querySelector('.variant-raw-price').value = matchedVariant.price;

            // 4. 수량 설정 - 가용 수량으로 max 설정
            const qtyInput = itemRow.querySelector('.quantity__input');
            if (availableQty <= 0) {
                qtyInput.max = 0;
                qtyInput.min = 0;
                qtyInput.value = 0;
            } else {
                qtyInput.max = availableQty;
                qtyInput.value = 1;
            }

            //이벤트 리스너 연결
            //삭제 버튼
            itemRow.querySelector('.remove-variant-btn').addEventListener('click', function() {
                itemRow.remove();
                updateTotalSummary(); // 삭제 시 총액 재계산
            });

            //수량 변경 감지 (플러스/마이너스 버튼 및 직접 입력)
            // 테마의 quantity-input 동작과 별개로 총액 계산을 위해 change 이벤트 감지
            qtyInput.addEventListener('change', updateTotalSummary);

            const plusBtn = itemRow.querySelector('button[name="plus"]');
            const minusBtn = itemRow.querySelector('button[name="minus"]');

            plusBtn.addEventListener('click', () => {
                // 약간의 지연을 준담 input 값이 업데이트 된 후 계산 테마 지연 고려함
                setTimeout(updateTotalSummary, 50);
            });
            minusBtn.addEventListener('click', () => {
                setTimeout(updateTotalSummary, 50);
            });

            // 리스트에 추가
            selectedContainer.appendChild(clone);

            // 초기화 및 업데이트
            container.querySelectorAll('.cc-active').forEach(el => el.classList.remove('cc-active'));
            refreshOptionState();
            updateTotalSummary(); //총액 재계산
        }
    }

    // --- 메인 이벤트 리스너 ---
    container.addEventListener('click', function(e) {
        const btn = e.target.closest('.cc-variant-option-value');
        if (!btn || btn.classList.contains('unavailable')) return;

        const row = btn.closest('.cc-variant-option-values');
        const prevActive = row.querySelector('.cc-active');

        if (prevActive === btn) {
            btn.classList.remove('cc-active');
        } else {
            if (prevActive) prevActive.classList.remove('cc-active');
            btn.classList.add('cc-active');
        }

        refreshOptionState();
        addVariantToList();
        clearOptionErrors();
    });

    // 초기 실행
    refreshOptionState();

    if (form) {
        form.addEventListener('submit', function(e) {
            const items = selectedContainer.querySelectorAll('.selected-variant-item');
            if (items.length === 0) {
                e.preventDefault();
                showOptionErrors();
            }
        });
    }
});

async function executeCheckout() {
    const directBuyBtn = document.querySelector('.cart-direct-buy-btn');
    const selectedContainer = document.getElementById('selected-variants-container');

    if (!directBuyBtn || !selectedContainer) return;

    //더븤클릭 방지 부모요소에 태그 검사
    const parentEl = directBuyBtn.parentElement;

    //이미 처리 중이면 함수 종료
    if (parentEl.classList.contains('double-click-limit')) {
        return;
    }

    const items = selectedContainer.querySelectorAll('.selected-variant-item');

    // 2. 옵션 선택 여부 체크
    if (items.length === 0) {
        if (typeof window.showOptionErrors === 'function') {
            window.showOptionErrors();
        }
        return;
    }

    // 클릭 즉시 double-click-limit을 넣어서 덥클 최대한 방지
    parentEl.classList.add('double-click-limit');

    const originalText = directBuyBtn.innerText;
    directBuyBtn.innerText = "처리 중...";

    //리다이렉트 중인지
    let isRedirecting = false;

    try {
        //GraphQL 변수
        const lines = Array.from(items).map(item => {
            const idVal = item.querySelector('.variant-id-input').value;
            const qtyVal = item.querySelector('.quantity__input').value;

            return {
                merchandiseId: `gid://shopify/ProductVariant/${idVal}`,
                quantity: parseInt(qtyVal, 10),
                attributes: []
            };
        });

        const query = `
      mutation cartCreate($input: CartInput!, $country: CountryCode, $language: LanguageCode) @inContext(country: $country, language: $language) {
        result: cartCreate(input: $input) {
          cart { checkoutUrl }
          userErrors { message field code }
        }
      }
    `;

        const variables = {
            input: { lines: lines, discountCodes: [] },
            country: "KR",
            language: "KO"
        };

        // 5. API 호출
        const response = await fetch('/api/2026-01/graphql.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ query, variables })
        });

        const json = await response.json();

        if (json.errors) throw new Error(JSON.stringify(json.errors));

        const result = json.data.result;

        //사용자 에러 체크 (재고 부족 등)
        if (result.userErrors && result.userErrors.length > 0) {
            const msg = result.userErrors.map(e => e.message).join('\n');
            alert("구매 불가: " + msg);
            return; // 에러이므로 finally로 넘어가서 버튼이 다시 풀림
        }

        //체크아웃 이동
        if (result.cart && result.cart.checkoutUrl) {
            isRedirecting = true; // 이동 중 ㅇ
            window.location.href = result.cart.checkoutUrl;
        }

    } catch (error) {
        console.error("Checkout Error:", error);
        alert("구매 처리 중 오류가 발생했습니다.");
    } finally {
        //이동ㅈ안할때만
        if (!isRedirecting) {
            parentEl.classList.remove('double-click-limit');
            directBuyBtn.innerText = originalText;
        }
    }
}

window.addEventListener('pageshow', (event) => {
    // persisted true: bfcache 복원
    if (event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
      window.dispatchEvent(new Event('clear-product-buy-sheet-cart'));
  
      const directBuyBtn = document.querySelector('.cart-direct-buy-btn');
      const parentEl = directBuyBtn?.parentElement;
      if (parentEl) parentEl.classList.remove('double-click-limit');
      if (directBuyBtn) directBuyBtn.innerText = '구매하기'; // 또는 원래 텍스트 복구
    }
  });